(function(){'use strict';

var CFG = window.CR_CONFIG || {};
var FREE_SHIP_THRESHOLD_CENTS = CFG.freeShippingThreshold || 8000;
var PROTECT_VARIANT_ID = CFG.protectionVariantId || 0;
var PROTECT_PRICE_CENTS = CFG.protectionPriceCents || 299;

function money(cents){ return '$' + (cents/100).toFixed(2); }

/* Spring sale countdown */
function startCountdown(){
  var nodes = document.querySelectorAll('[data-cr-countdown]');
  if(!nodes.length) return;
  function tick(){
    var now = new Date();
    var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
    var diff = midnight - now; if(diff < 0) diff = 0;
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    var pad = function(n){return n < 10 ? '0' + n : String(n);};
    nodes.forEach(function(n){
      var hEl = n.querySelector('[data-h]'); var mEl = n.querySelector('[data-m]'); var sEl = n.querySelector('[data-s]');
      if(hEl) hEl.textContent = pad(h); if(mEl) mEl.textContent = pad(m); if(sEl) sEl.textContent = pad(s);
    });
  }
  tick(); setInterval(tick, 1000);
}
startCountdown();

/* Header hide on scroll down */
(function(){
  var header = document.querySelector('.cr-header');
  if(!header) return;
  var lastY = window.pageYOffset || 0;
  var ticking = false;
  function onScroll(){
    var y = window.pageYOffset || 0;
    if(y < 80){ header.classList.remove('cr-hidden'); lastY = y; ticking = false; return; }
    if(y > lastY + 4){ header.classList.add('cr-hidden'); }
    else if(y < lastY - 4){ header.classList.remove('cr-hidden'); }
    lastY = y; ticking = false;
  }
  window.addEventListener('scroll', function(){ if(!ticking){ window.requestAnimationFrame(onScroll); ticking = true; } }, {passive:true});
})();

/* Accordions / FAQ */
function wireAccordions(root){
  (root || document).querySelectorAll('.cr-accordion-header, .cr-faq-question').forEach(function(h){
    if(h.dataset.crWired) return; h.dataset.crWired = '1';
    h.addEventListener('click', function(){ this.parentElement.classList.toggle('open'); });
  });
}
wireAccordions();

/* Product gallery */
(function(){
  var gallery = document.querySelector('.cr-gallery');
  if(!gallery) return;
  var main = gallery.querySelector('.cr-gallery-main');
  var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.cr-gallery-thumb'));
  if(!main) return;
  function isMobile(){ return window.matchMedia('(max-width: 767px)').matches; }
  function buildSlides(){
    if(main.querySelector('.cr-gallery-slide')) return;
    var srcs = thumbs.map(function(t){ return t.dataset.image || (t.querySelector('img') && t.querySelector('img').src); }).filter(Boolean);
    if(!srcs.length){ var firstImg = main.querySelector('img'); if(firstImg) srcs.push(firstImg.src); }
    main.innerHTML = '';
    srcs.forEach(function(src){ var slide = document.createElement('div'); slide.className = 'cr-gallery-slide'; slide.innerHTML = '<img src="' + src + '" alt="" loading="lazy">'; main.appendChild(slide); });
    if(!gallery.querySelector('.cr-gallery-dots') && srcs.length > 1){
      var dots = document.createElement('div'); dots.className = 'cr-gallery-dots';
      srcs.forEach(function(_, i){ var dot = document.createElement('span'); dot.className = 'cr-gallery-dot' + (i === 0 ? ' active' : ''); dots.appendChild(dot); });
      main.parentNode.insertBefore(dots, main.nextSibling);
    }
  }
  function setActiveSlide(idx){
    var dots = gallery.querySelectorAll('.cr-gallery-dot');
    dots.forEach(function(d,i){ d.classList.toggle('active', i === idx); });
    thumbs.forEach(function(t,i){ t.classList.toggle('active', i === idx); });
  }
  buildSlides();
  if(main){
    var scrollTimer;
    main.addEventListener('scroll', function(){
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function(){ var slideW = main.offsetWidth; if(slideW > 0){ var idx = Math.round(main.scrollLeft / slideW); setActiveSlide(idx); } }, 80);
    }, {passive:true});
  }
  thumbs.forEach(function(thumb, idx){
    thumb.addEventListener('click', function(){
      var slides = main.querySelectorAll('.cr-gallery-slide');
      if(slides[idx]){
        if(isMobile()){ main.scrollTo({left: slides[idx].offsetLeft - main.offsetLeft, behavior:'smooth'}); }
        else { var img = slides[0] && slides[0].querySelector('img'); if(img) img.src = thumb.dataset.image || (thumb.querySelector('img') && thumb.querySelector('img').src); setActiveSlide(idx); }
      }
      setActiveSlide(idx);
    });
  });
})();

/* Sticky ATC visibility */
(function(){
  var stickyATC = document.getElementById('cr-sticky-atc');
  var mainATC = document.getElementById('cr-atc-btn');
  if(stickyATC && mainATC && 'IntersectionObserver' in window){
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){ stickyATC.classList.remove('visible'); }
        else if(entry.boundingClientRect.top < 0){ stickyATC.classList.add('visible'); }
      });
    }, {threshold: 0});
    observer.observe(mainATC);
  }
})();

/* Legacy video cards (homepage hero, etc.) — the dedicated PDP video section
   (cr-product-videos) has its own self-contained script. */
document.querySelectorAll('.cr-video-card').forEach(function(card){
  card.addEventListener('click', function(){
    var video = this.querySelector('video');
    if(!video) return;
    if(video.paused){ video.play(); video.setAttribute('controls', ''); var play = this.querySelector('.cr-video-play'); if(play) play.style.display = 'none'; }
    else { video.pause(); }
  });
});

/* Mobile menu */
var mobileMenu = document.getElementById('cr-mobile-nav');
var menuBtn = document.getElementById('cr-menu-btn');
var menuClose = document.getElementById('cr-mobile-nav-close');
if(menuBtn && mobileMenu){ menuBtn.addEventListener('click', function(){ mobileMenu.classList.add('open'); document.body.classList.add('no-scroll'); }); }
if(menuClose && mobileMenu){ menuClose.addEventListener('click', function(){ mobileMenu.classList.remove('open'); document.body.classList.remove('no-scroll'); }); }

/* ============================================================
   Cart drawer — INSTANT open, fully optimistic UI, never flickers
   ============================================================ */
var cartDrawer = document.getElementById('cr-cart-drawer');
var cartOverlay = document.getElementById('cr-cart-overlay');
var cartClose = document.getElementById('cr-cart-close');

var CART_STATE = null;
var INITIAL_ITEM_COUNT = 0;
var inFlightOps = 0;

/* ============================================================
   ANALYTICS LAYER — fires Shopify Web Pixel customer events on
   every cart add. Powers Meta Pixel, Facebook Conversions API,
   Google & YouTube, GA4, TikTok, Pinterest, Snap — every pixel
   subscribed to Shopify customer events. Without this, the
   custom cart drawer adds items silently and no pixel sees them.
   ============================================================ */
var PREV_CART_LINES = {};            // key -> line snapshot from last known cart
var ANALYTICS_INITIALIZED = false;    // skip diff on first cart fetch
var CR_CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

function crSnapshotCart(cart){
  var snap = {};
  if(!cart || !cart.items) return snap;
  cart.items.forEach(function(it){
    snap[it.key] = {
      key: it.key,
      variant_id: it.variant_id,
      product_id: it.product_id,
      product_title: it.product_title || it.title || '',
      variant_title: it.variant_title || '',
      vendor: it.vendor || '',
      sku: it.sku || '',
      quantity: it.quantity,
      final_price: it.final_price,
      final_line_price: it.final_line_price
    };
  });
  return snap;
}

function crPublishAddToCart(addedItems){
  if(!addedItems || !addedItems.length) return;
  try {
    // 1) Shopify native publish — powers Meta Pixel app, Meta CAPI,
    //    Google channel, GA4, TikTok, Pinterest, Snap, Klaviyo, etc.
    if(window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function'){
      addedItems.forEach(function(item){
        window.Shopify.analytics.publish('product_added_to_cart', {
          cartLine: {
            merchandise: {
              id: 'gid://shopify/ProductVariant/' + item.variant_id,
              title: item.variant_title || item.product_title,
              sku: item.sku || '',
              product: {
                id: 'gid://shopify/Product/' + item.product_id,
                title: item.product_title,
                vendor: item.vendor || '',
                type: ''
              },
              price: {
                amount: (item.final_price / 100).toFixed(2),
                currencyCode: CR_CURRENCY
              }
            },
            quantity: item.quantity,
            cost: {
              totalAmount: {
                amount: (item.final_line_price / 100).toFixed(2),
                currencyCode: CR_CURRENCY
              }
            }
          }
        });
      });
    }

    // 2) DOM CustomEvent — picked up by GTM and any custom listeners
    addedItems.forEach(function(item){
      document.dispatchEvent(new CustomEvent('cart:item-added', {
        bubbles: true,
        detail: {
          variantId: item.variant_id,
          productId: item.product_id,
          productTitle: item.product_title,
          variantTitle: item.variant_title,
          quantity: item.quantity,
          price: item.final_price,
          linePrice: item.final_line_price,
          currency: CR_CURRENCY,
          sku: item.sku || ''
        }
      }));
    });

    // 3) dataLayer — for Google Tag Manager / GA4 / Google Ads
    window.dataLayer = window.dataLayer || [];
    if(typeof window.dataLayer.push === 'function'){
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: CR_CURRENCY,
          value: addedItems.reduce(function(s, i){ return s + (i.final_line_price / 100); }, 0),
          items: addedItems.map(function(i){
            return {
              item_id: String(i.product_id),
              item_variant_id: String(i.variant_id),
              item_name: i.product_title,
              item_variant: i.variant_title || '',
              quantity: i.quantity,
              price: (i.final_price / 100).toFixed(2)
            };
          })
        }
      });
    }
  } catch(e){
    if(window.console && console.warn) console.warn('CR analytics ATC publish failed', e);
  }
}

function crPublishCartViewed(cart){
  if(!cart || !cart.items) return;
  try {
    if(window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function'){
      window.Shopify.analytics.publish('cart_viewed', {
        cart: {
          totalQuantity: cart.item_count,
          cost: {
            totalAmount: {
              amount: (cart.total_price / 100).toFixed(2),
              currencyCode: CR_CURRENCY
            }
          },
          lines: cart.items.map(function(it){
            return {
              quantity: it.quantity,
              merchandise: {
                id: 'gid://shopify/ProductVariant/' + it.variant_id,
                title: it.variant_title || it.product_title || '',
                sku: it.sku || '',
                product: {
                  id: 'gid://shopify/Product/' + it.product_id,
                  title: it.product_title || it.title || '',
                  vendor: it.vendor || '',
                  type: ''
                },
                price: {
                  amount: (it.final_price / 100).toFixed(2),
                  currencyCode: CR_CURRENCY
                }
              },
              cost: {
                totalAmount: {
                  amount: (it.final_line_price / 100).toFixed(2),
                  currencyCode: CR_CURRENCY
                }
              }
            };
          })
        }
      });
    }
    document.dispatchEvent(new CustomEvent('cart:viewed', {
      bubbles: true,
      detail: { cart: cart, currency: CR_CURRENCY }
    }));
  } catch(e){
    if(window.console && console.warn) console.warn('CR analytics cart_viewed publish failed', e);
  }
}

function crDiffCartAndPublish(newCart){
  if(!newCart || !newCart.items) return;
  var newSnap = crSnapshotCart(newCart);

  // First call ever — just snapshot (don't fire ATC for pre-existing items)
  if(!ANALYTICS_INITIALIZED){
    PREV_CART_LINES = newSnap;
    ANALYTICS_INITIALIZED = true;
    return;
  }

  var added = [];
  Object.keys(newSnap).forEach(function(key){
    var newLine = newSnap[key];
    var prevLine = PREV_CART_LINES[key];
    // Skip shipping protection — it's not a real product add
    if(PROTECT_VARIANT_ID && newLine.variant_id === PROTECT_VARIANT_ID) return;
    var deltaQty = newLine.quantity - (prevLine ? prevLine.quantity : 0);
    if(deltaQty > 0){
      added.push({
        variant_id: newLine.variant_id,
        product_id: newLine.product_id,
        product_title: newLine.product_title,
        variant_title: newLine.variant_title,
        vendor: newLine.vendor,
        sku: newLine.sku,
        quantity: deltaQty,
        final_price: newLine.final_price,
        final_line_price: newLine.final_price * deltaQty
      });
    }
  });

  PREV_CART_LINES = newSnap;
  if(added.length){ crPublishAddToCart(added); }
}

/* ============================================================
   Global fetch interception — catches ANY /cart/add.js call
   whether from this drawer, Kaching Bundles, Kaching Subscriptions,
   sticky ATC, or any third-party app. After every cart mutation,
   we refetch and diff so analytics fire reliably.
   ============================================================ */
(function patchFetchForCart(){
  if(!window.fetch || window.fetch.__crPatched) return;
  var orig = window.fetch;
  window.fetch = function(input, init){
    var p = orig.apply(this, arguments);
    try {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var method = (init && init.method) || (input && input.method) || 'GET';
      method = String(method).toUpperCase();
      if(method === 'POST' && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1)){
        p.then(function(res){
          // Single belt-and-suspenders refetch after the mutation settles to catch async app handlers.
          setTimeout(function(){ try { fetchCart(); } catch(e){} }, 150);
          return res;
        }).catch(function(){});
      }
    } catch(e){ /* never break fetch */ }
    return p;
  };
  window.fetch.__crPatched = true;
})();

(function(){
  var el = document.querySelector('[data-cr-cart-count]');
  if(el){ INITIAL_ITEM_COUNT = parseInt(el.textContent, 10) || 0; }
})();

function isProtectionItem(item){ return PROTECT_VARIANT_ID && item.variant_id === PROTECT_VARIANT_ID; }

function setCountEverywhere(n){
  document.querySelectorAll('[data-cr-cart-count]').forEach(function(el){
    el.textContent = n;
    if(n === 0){ el.classList.add('is-empty'); } else { el.classList.remove('is-empty'); }
  });
  INITIAL_ITEM_COUNT = n;
}

function userFacingCount(cart){
  if(!cart) return 0;
  var n = cart.item_count;
  cart.items.forEach(function(it){ if(isProtectionItem(it)) n -= it.quantity; });
  return n;
}

function skeletonHTML(count){
  var n = Math.min(count || 1, 3);
  var rows = '';
  for(var i = 0; i < n; i++){
    rows += '<div class="cr-cart-skeleton-row"><div class="cr-cart-skeleton-img"></div><div class="cr-cart-skeleton-text"><div></div><div></div></div></div>';
  }
  return '<div class="cr-cart-skeleton" style="padding:20px;">' + rows + '</div>';
}

function openCart(){
  if(!cartDrawer) return;
  cartDrawer.classList.add('open');
  if(cartOverlay) cartOverlay.classList.add('open');
  document.body.classList.add('no-scroll');
  if(CART_STATE){
    renderCart(CART_STATE);
  } else {
    var body = document.getElementById('cr-cart-body');
    if(body){
      if(INITIAL_ITEM_COUNT > 0){ body.innerHTML = skeletonHTML(INITIAL_ITEM_COUNT); }
      else { body.innerHTML = '<div class="cr-cart-empty"><div class="icon">🛒</div><p>Your cart is empty</p></div>'; }
    }
  }
  fetchCart().then(function(cart){
    if(cart && cart.item_count > 0) crPublishCartViewed(cart);
  });
}
function closeCart(){
  if(!cartDrawer) return;
  cartDrawer.classList.remove('open');
  if(cartOverlay) cartOverlay.classList.remove('open');
  document.body.classList.remove('no-scroll');
}

document.addEventListener('click', function(e){
  var t = e.target;
  while(t && t !== document){
    if(t.matches && t.matches('[data-cr-open-cart]')){ e.preventDefault(); openCart(); return; }
    t = t.parentNode;
  }
});
if(cartClose) cartClose.addEventListener('click', closeCart);
if(cartOverlay) cartOverlay.addEventListener('click', closeCart);

document.addEventListener('keydown', function(e){
  if(e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('open')){
    closeCart();
  }
});

function fetchCart(){
  return fetch('/cart.js', {headers:{'Accept':'application/json'}, credentials:'same-origin'})
    .then(function(r){return r.json();})
    .then(function(cart){
      CART_STATE = cart;
      crDiffCartAndPublish(cart);              // <-- analytics hook
      if(inFlightOps === 0) renderCart(cart);
      else setCountEverywhere(userFacingCount(cart));
      return cart;
    })
    .catch(function(err){console.error('Cart fetch failed', err);});
}

function renderShipBar(subtotal){
  var pct = Math.min(100, Math.round((subtotal / FREE_SHIP_THRESHOLD_CENTS) * 100));
  var remaining = Math.max(0, FREE_SHIP_THRESHOLD_CENTS - subtotal);
  var unlocked = remaining === 0;
  var truckIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 17 16 17 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>';
  var checkIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
  return '<div class="cr-ship-bar"><div class="cr-ship-bar-text' + (unlocked ? ' unlocked' : '') + '"><span class="icon">' + (unlocked ? checkIcon : truckIcon) + '</span><span>' + (unlocked ? "You've unlocked <strong>FREE shipping</strong>!" : "You're <strong>" + money(remaining) + "</strong> away from free shipping") + '</span></div><div class="cr-ship-bar-track"><div class="cr-ship-bar-fill' + (unlocked ? ' unlocked' : '') + '" style="width:' + pct + '%"></div></div></div>';
}

function renderProtectBlock(isActive){
  return '<div class="cr-protect-block' + (isActive ? ' active' : '') + '" id="cr-protect-block"><div class="cr-protect-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg></div><div class="cr-protect-info"><div class="cr-protect-title">Shipping Protection <span class="cr-protect-price">' + money(PROTECT_PRICE_CENTS) + '</span></div><div class="cr-protect-desc">Covers lost, stolen, or damaged packages.</div></div><button type="button" class="cr-protect-toggle" id="cr-protect-toggle" aria-pressed="' + (isActive ? 'true' : 'false') + '" aria-label="Toggle shipping protection"></button></div>';
}

function renderCart(cart){
  CART_STATE = cart;
  var body = document.getElementById('cr-cart-body');
  var footer = document.getElementById('cr-cart-footer');

  var protectionItem = null;
  cart.items.forEach(function(it){ if(isProtectionItem(it)) protectionItem = it; });
  var protectionActive = !!protectionItem;

  var realCount = userFacingCount(cart);
  setCountEverywhere(realCount);

  if(!body) return;
  if(realCount === 0){
    body.innerHTML = '<div class="cr-cart-empty"><div class="icon">🛒</div><p>Your cart is empty</p></div>';
    if(footer) { footer.style.display = 'none'; footer.innerHTML = ''; }
    if(protectionItem){
      fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id: protectionItem.key, quantity: 0}), credentials:'same-origin'}).catch(function(){});
    }
    return;
  }
  if(footer) footer.style.display = 'block';

  var subtotalExclProtect = cart.total_price - (protectionItem ? protectionItem.final_line_price : 0);
  var html = renderShipBar(subtotalExclProtect);

  var itemsHTML = '';
  cart.items.forEach(function(item){
    if(isProtectionItem(item)) return;
    var lineBaseline = 4999 * item.quantity;
    var lineSave = lineBaseline - item.final_line_price;
    var wasPrice = lineSave > 0 ? '<span class="was" data-cr-line-was>' + money(lineBaseline) + '</span>' : '';
    var savings = lineSave > 0 ? '<span class="save" data-cr-line-save>You save $' + (lineSave/100).toFixed(2) + '</span>' : '';
    var unit = item.final_price;
    itemsHTML += '<div class="cr-cart-item" data-key="' + item.key + '" data-unit="' + unit + '" data-line-baseline="' + lineBaseline + '">';
    itemsHTML += '<div class="cr-cart-item-img">' + (item.image ? '<img src="' + item.image + '" alt="">' : '') + '</div>';
    itemsHTML += '<div class="cr-cart-item-info"><div class="cr-cart-item-title">' + item.product_title + '</div>';
    itemsHTML += '<div class="cr-cart-item-qty"><button type="button" data-cr-qty-down aria-label="Decrease">−</button><span data-cr-qty-num>' + item.quantity + '</span><button type="button" data-cr-qty-up aria-label="Increase">+</button></div></div>';
    itemsHTML += '<div class="cr-cart-item-price">' + wasPrice + '<span class="now" data-cr-line-price>' + money(item.final_line_price) + '</span>' + savings + '</div>';
    itemsHTML += '<button type="button" class="cr-cart-remove" data-cr-remove aria-label="Remove">✕</button></div>';
  });
  html += '<div style="padding:8px 20px;">' + itemsHTML + '</div>';
  body.innerHTML = html;

  if(footer){
    var crUnits = 0;
    cart.items.forEach(function(it){ if(!isProtectionItem(it)) crUnits += it.quantity; });
    var crBaseSubtotal = cart.total_price - (protectionItem ? protectionItem.final_line_price : 0);
    var crSavings = (crUnits * 4999) - crBaseSubtotal;
    var savingsHTML = crSavings > 0 ? '<div class="cr-cart-line savings" style="color:#1f8a4c;font-weight:700;"><span>You saved</span><span>' + money(crSavings) + '</span></div>' : '';
    var protectLine = protectionActive ? '<div class="cr-cart-line" data-cr-protect-line><span>Shipping Protection</span><span>' + money(protectionItem.final_line_price) + '</span></div>' : '';
    var freeShipLine = subtotalExclProtect >= FREE_SHIP_THRESHOLD_CENTS ? '<div class="cr-cart-line shipping"><span class="label">Shipping</span><span>FREE</span></div>' : '';
    footer.innerHTML = (PROTECT_VARIANT_ID ? renderProtectBlock(protectionActive) : '') +
      '<div class="cr-cart-summary">' + savingsHTML + protectLine + freeShipLine +
      '<div class="cr-cart-line total"><span>Subtotal</span><span data-cr-subtotal>' + money(cart.total_price) + '</span></div></div>' +
      '<a href="/checkout" class="cr-cart-checkout" role="button" style="display:flex;text-decoration:none;">Check out →</a>' +
      '<div class="cr-cart-guarantee"><span class="icon">✓</span> 90-Day Money-Back Guarantee</div>';
  }
  attachCartItemHandlers();
  attachProtectToggle(protectionActive, protectionItem);
}

function attachCartItemHandlers(){
  document.querySelectorAll('.cr-cart-item').forEach(function(item){
    var key = item.dataset.key;
    var qtyUp = item.querySelector('[data-cr-qty-up]');
    var qtyDown = item.querySelector('[data-cr-qty-down]');
    var remove = item.querySelector('[data-cr-remove]');
    var qtySpan = item.querySelector('[data-cr-qty-num]');
    if(qtyUp) qtyUp.addEventListener('click', function(){
      var current = parseInt(qtySpan.textContent, 10) || 0;
      changeLineOptimistic(key, current + 1);
    });
    if(qtyDown) qtyDown.addEventListener('click', function(){
      var current = parseInt(qtySpan.textContent, 10) || 0;
      changeLineOptimistic(key, current - 1);
    });
    if(remove) remove.addEventListener('click', function(){
      changeLineOptimistic(key, 0);
    });
  });
}

function changeLineOptimistic(key, quantity){
  if(quantity < 0) quantity = 0;
  var itemEl = document.querySelector('.cr-cart-item[data-key="' + key + '"]');
  if(!itemEl){
    return updateLineServer(key, quantity);
  }
  var qtySpan = itemEl.querySelector('[data-cr-qty-num]');
  var priceEl = itemEl.querySelector('[data-cr-line-price]');
  var unit = parseInt(itemEl.dataset.unit, 10) || 0;
  if(quantity === 0){
    itemEl.style.transition = 'opacity .15s, transform .15s, max-height .2s, padding .2s, margin .2s';
    itemEl.style.opacity = '0';
    itemEl.style.transform = 'translateX(20px)';
    itemEl.style.maxHeight = '0';
    itemEl.style.padding = '0';
    itemEl.style.margin = '0';
    itemEl.style.overflow = 'hidden';
    itemEl.dataset.crRemoving = '1';
    setTimeout(function(){ if(itemEl.parentNode) itemEl.parentNode.removeChild(itemEl); checkIfCartEmpty(); }, 180);
  } else {
    if(qtySpan) qtySpan.textContent = quantity;
    if(priceEl) priceEl.textContent = money(unit * quantity);
    var wasEl = itemEl.querySelector('[data-cr-line-was]');
    var saveEl = itemEl.querySelector('[data-cr-line-save]');
    var newBaseline = 4999 * quantity;
    var newSave = newBaseline - (unit * quantity);
    itemEl.dataset.lineBaseline = newBaseline;
    if(newSave > 0){
      if(wasEl) wasEl.textContent = money(newBaseline);
      if(saveEl) saveEl.textContent = 'You save $' + (newSave/100).toFixed(2);
    } else {
      if(wasEl) wasEl.style.display = 'none';
      if(saveEl) saveEl.style.display = 'none';
    }
  }
  recomputeOptimisticSubtotal();
  updateLineServer(key, quantity);
}

function checkIfCartEmpty(){
  var anyItems = document.querySelectorAll('.cr-cart-item:not([data-cr-removing])').length > 0;
  var body = document.getElementById('cr-cart-body');
  var footer = document.getElementById('cr-cart-footer');
  if(!anyItems && body){
    body.innerHTML = '<div class="cr-cart-empty"><div class="icon">🛒</div><p>Your cart is empty</p></div>';
    if(footer){ footer.style.display = 'none'; footer.innerHTML = ''; }
    setCountEverywhere(0);
  }
}

function recomputeOptimisticSubtotal(){
  var sub = 0;
  var qtyTotal = 0;
  document.querySelectorAll('.cr-cart-item').forEach(function(item){
    if(item.dataset.crRemoving) return;
    var qtySpan = item.querySelector('[data-cr-qty-num]');
    var unit = parseInt(item.dataset.unit, 10) || 0;
    var q = parseInt(qtySpan && qtySpan.textContent, 10) || 0;
    sub += unit * q;
    qtyTotal += q;
  });
  var protectLine = document.querySelector('[data-cr-protect-line]');
  if(protectLine) sub += PROTECT_PRICE_CENTS;
  var subtotalEl = document.querySelector('[data-cr-subtotal]');
  if(subtotalEl) subtotalEl.textContent = money(sub);
  setCountEverywhere(qtyTotal);

  var savedEl = document.querySelector('.cr-cart-line.savings span:last-child');
  if(savedEl){
    var subForSaving = sub - (protectLine ? PROTECT_PRICE_CENTS : 0);
    var crSavings = (qtyTotal * 4999) - subForSaving;
    var row = savedEl.closest('.cr-cart-line.savings');
    if(crSavings > 0){ savedEl.textContent = money(crSavings); if(row) row.style.display = ''; }
    else if(row){ row.style.display = 'none'; }
  }

  var fillEl = document.querySelector('.cr-ship-bar-fill');
  var textEl = document.querySelector('.cr-ship-bar-text');
  if(fillEl && textEl){
    var subForShip = sub - (protectLine ? PROTECT_PRICE_CENTS : 0);
    var pct = Math.min(100, Math.round((subForShip / FREE_SHIP_THRESHOLD_CENTS) * 100));
    var remaining = Math.max(0, FREE_SHIP_THRESHOLD_CENTS - subForShip);
    var unlocked = remaining === 0;
    fillEl.style.width = pct + '%';
    fillEl.classList.toggle('unlocked', unlocked);
    textEl.classList.toggle('unlocked', unlocked);
    var span = textEl.querySelectorAll('span')[1];
    if(span){
      span.innerHTML = unlocked ? "You've unlocked <strong>FREE shipping</strong>!" : "You're <strong>" + money(remaining) + "</strong> away from free shipping";
    }
  }
}

function updateLineServer(key, quantity){
  inFlightOps++;
  return fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id: key, quantity: quantity}), credentials:'same-origin'})
    .then(function(r){return r.json();})
    .then(function(cart){
      CART_STATE = cart;
      crDiffCartAndPublish(cart);
      inFlightOps = Math.max(0, inFlightOps - 1);
      if(inFlightOps === 0){
        setTimeout(function(){
          if(inFlightOps === 0){
            if(cart.item_count === 0){
              var body = document.getElementById('cr-cart-body');
              var footer = document.getElementById('cr-cart-footer');
              if(body){ body.innerHTML = '<div class="cr-cart-empty"><div class="icon">🛒</div><p>Your cart is empty</p></div>'; }
              if(footer){ footer.style.display = 'none'; footer.innerHTML = ''; }
              setCountEverywhere(0);
            } else {
              renderCart(cart);
            }
          }
        }, 80);
      } else {
        setCountEverywhere(userFacingCount(cart));
      }
      return cart;
    })
    .catch(function(err){
      console.error('Cart update failed', err);
      inFlightOps = Math.max(0, inFlightOps - 1);
      fetchCart();
    });
}

function attachProtectToggle(isActive, protectionItem){
  var toggle = document.getElementById('cr-protect-toggle');
  var block = document.getElementById('cr-protect-block');
  if(!toggle || !PROTECT_VARIANT_ID) return;
  var busy = false;
  toggle.addEventListener('click', function(){
    if(busy) return; busy = true;
    var nowActive = !isActive;
    toggle.setAttribute('aria-pressed', nowActive ? 'true' : 'false');
    if(block){ block.classList.toggle('active', nowActive); }
    var summary = document.querySelector('.cr-cart-summary');
    if(summary){
      var existing = summary.querySelector('[data-cr-protect-line]');
      if(nowActive && !existing){
        var line = document.createElement('div'); line.className = 'cr-cart-line'; line.dataset.crProtectLine = '1';
        line.innerHTML = '<span>Shipping Protection</span><span>' + money(PROTECT_PRICE_CENTS) + '</span>';
        var total = summary.querySelector('.cr-cart-line.total');
        if(total){ summary.insertBefore(line, total); }
      } else if(!nowActive && existing){
        existing.remove();
      }
    }
    recomputeOptimisticSubtotal();
    inFlightOps++;
    var request;
    if(isActive && protectionItem){
      request = fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id: protectionItem.key, quantity: 0}), credentials:'same-origin'});
    } else {
      request = fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({id: PROTECT_VARIANT_ID, quantity: 1, properties:{'_protection':'yes'}}), credentials:'same-origin'});
    }
    request.then(function(r){return r.json();}).then(function(){
      inFlightOps = Math.max(0, inFlightOps - 1);
      return fetchCart();
    }).catch(function(err){
      console.error('Protect toggle failed', err);
      inFlightOps = Math.max(0, inFlightOps - 1);
      fetchCart();
    }).then(function(){ busy = false; });
  });
}

document.querySelectorAll('form[action="/cart/add"], form[action="/cart/add.js"]').forEach(function(form){
  form.addEventListener('submit', function(e){
    e.preventDefault();
    var data = new FormData(form);
    var qty = parseInt(data.get('quantity') || '1', 10) || 1;
    setCountEverywhere(INITIAL_ITEM_COUNT + qty);
    if(cartDrawer){
      cartDrawer.classList.add('open');
      if(cartOverlay) cartOverlay.classList.add('open');
      document.body.classList.add('no-scroll');
      var body = document.getElementById('cr-cart-body');
      if(body){
        if(CART_STATE && CART_STATE.item_count > 0){
          renderCart(CART_STATE);
          var holder = body.querySelector('div[style]') || body;
          var holderFirst = holder.firstChild;
          var skel = document.createElement('div');
          skel.className = 'cr-cart-skeleton-row';
          skel.innerHTML = '<div class="cr-cart-skeleton-img"></div><div class="cr-cart-skeleton-text"><div></div><div></div></div>';
          holder.insertBefore(skel, holderFirst);
        } else {
          body.innerHTML = skeletonHTML((INITIAL_ITEM_COUNT || 0) + qty);
        }
      }
    }
    inFlightOps++;
    fetch('/cart/add.js', {method:'POST', body: data, credentials:'same-origin'})
      .then(function(r){return r.json();})
      .then(function(){
        inFlightOps = Math.max(0, inFlightOps - 1);
        return fetchCart();
      })
      .catch(function(err){
        console.error('Add to cart failed', err);
        inFlightOps = Math.max(0, inFlightOps - 1);
        fetchCart();
      });
  });
});

document.addEventListener('click', function(e){
  var t = e.target;
  while(t && t !== document){
    if(t.matches && t.matches('a.cr-cart-checkout, a[href="/checkout"], a[href^="/checkout?"]')){
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'begin_checkout',
          ecommerce: {
            currency: CR_CURRENCY,
            value: CART_STATE ? (CART_STATE.total_price / 100) : 0,
            items: (CART_STATE && CART_STATE.items || []).map(function(it){
              return {
                item_id: String(it.product_id),
                item_variant_id: String(it.variant_id),
                item_name: it.product_title || it.title,
                quantity: it.quantity,
                price: (it.final_price / 100).toFixed(2)
              };
            })
          }
        });
      } catch(err){ /* never block checkout */ }
      return;
    }
    t = t.parentNode;
  }
}, true);

if(cartDrawer){
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fetchCart);
  else fetchCart();
  function prefetchOnce(){
    document.removeEventListener('mouseover', prefetchHandler, true);
    document.removeEventListener('focusin', prefetchHandler, true);
    fetchCart();
  }
  function prefetchHandler(e){
    var t = e.target;
    while(t && t !== document){
      if(t.matches && t.matches('[data-cr-open-cart]')){ prefetchOnce(); return; }
      t = t.parentNode;
    }
  }
  document.addEventListener('mouseover', prefetchHandler, true);
  document.addEventListener('focusin', prefetchHandler, true);
}

function setupKachingSync(){
  var mount = document.getElementById('kaching-bundles');
  var priceCurrent = document.querySelector('.cr-price-current');
  var priceWas = document.querySelector('.cr-price-was');
  var priceSave = document.querySelector('.cr-price-save');
  if(!mount || !priceCurrent) return;

  function parseMoney(str){
    if(str == null) return null;
    if(typeof str === 'number') return Math.round(str * 100);
    var s = String(str).replace(/[^\d.,-]/g,'').replace(/,/g,'');
    if(!s) return null;
    var f = parseFloat(s); if(isNaN(f)) return null;
    if(s.indexOf('.') === -1 && f >= 1000) return Math.round(f);
    return Math.round(f * 100);
  }

  function readKachingState(){
    var selected = mount.querySelector('[aria-checked="true"], [data-selected="true"], .ka-selected, [data-ka-selected="true"], input[type="radio"]:checked, .selected');
    var totalCents = null, compareCents = null;
    if(selected){
      var c = selected.closest('[data-price], [data-ka-price], [data-total]') || selected;
      var p = c.getAttribute('data-price') || c.getAttribute('data-ka-price') || c.getAttribute('data-total') || c.getAttribute('data-ka-total');
      var cp = c.getAttribute('data-compare-at') || c.getAttribute('data-ka-compare-at') || c.getAttribute('data-compare') || c.getAttribute('data-ka-compare');
      if(p){ var pn = parseMoney(p); if(pn != null) totalCents = pn; }
      if(cp){ var cpn = parseMoney(cp); if(cpn != null) compareCents = cpn; }
      if(totalCents == null){
        var priceNode = selected.querySelector('[class*="price"]:not([class*="compare"]):not([class*="strike"]):not([class*="old"]):not([class*="was"])');
        if(priceNode){ var pn2 = parseMoney(priceNode.textContent); if(pn2 != null) totalCents = pn2; }
      }
      if(compareCents == null){
        var compareNode = selected.querySelector('[class*="compare"], [class*="strike"], [class*="old"], [class*="was"], s, del');
        if(compareNode){ var cn2 = parseMoney(compareNode.textContent); if(cn2 != null) compareCents = cn2; }
      }
    }
    if(totalCents == null){
      var totalEl = mount.querySelector('[data-ka-total], [data-ka-price], .ka-total, .ka-price-final, [class*="total"]:not([class*="old"]):not([class*="compare"])');
      if(totalEl){ var n = parseMoney(totalEl.getAttribute('data-ka-total') || totalEl.getAttribute('data-ka-price') || totalEl.textContent); if(n != null) totalCents = n; }
    }
    if(compareCents == null){
      var compareEl = mount.querySelector('[data-ka-compare], [data-ka-compare-at], .ka-compare, .ka-compare-at, s, del, [class*="compare"]');
      if(compareEl){ var c2 = parseMoney(compareEl.getAttribute('data-ka-compare') || compareEl.getAttribute('data-ka-compare-at') || compareEl.textContent); if(c2 != null) compareCents = c2; }
    }
    return {totalCents: totalCents, compareCents: compareCents};
  }

  function applyState(){
    var st = readKachingState();
    if(st.totalCents == null) return;
    priceCurrent.textContent = money(st.totalCents);
    if(st.compareCents != null && st.compareCents > st.totalCents){
      if(priceWas){ priceWas.textContent = money(st.compareCents); priceWas.style.display = ''; }
      if(priceSave){ var pct = Math.round((st.compareCents - st.totalCents) / st.compareCents * 100); priceSave.textContent = 'SAVE ' + pct + '%'; priceSave.style.display = ''; }
    } else {
      if(priceWas) priceWas.style.display = 'none';
      if(priceSave) priceSave.style.display = 'none';
    }
  }

  setTimeout(applyState, 800); setTimeout(applyState, 2000); setTimeout(applyState, 4000);
  mount.addEventListener('click', function(){ setTimeout(applyState, 50); setTimeout(applyState, 250); setTimeout(applyState, 600); });
  mount.addEventListener('change', function(){ setTimeout(applyState, 50); setTimeout(applyState, 250); });
  mount.addEventListener('input', function(){ setTimeout(applyState, 50); });
  ['kaching:bundle:select','kaching:select','ka:bundle:select','kachingbundles:select','bundle:change','offer:select','offer:change'].forEach(function(name){ document.addEventListener(name, applyState); mount.addEventListener(name, applyState); });
  if(window.MutationObserver){
    var mo = new MutationObserver(function(){ applyState(); });
    mo.observe(mount, {childList:true, subtree:true, attributes:true, attributeFilter:['data-selected','aria-checked','data-ka-selected','data-ka-price','data-ka-total','data-price','data-variant-id','class']});
  }
  var pollCount = 0; var pollIv = setInterval(function(){ applyState(); if(++pollCount > 10) clearInterval(pollIv); }, 2000);
}
setupKachingSync();

})();
